






































































import { PropType, defineComponent } from '@nuxtjs/composition-api';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useProductConfigurationOptions } from '~/features/productConfigurationOption';
import { ProductContext } from '~/features/productContext';
import { isColor } from '~/utils/text';

export default defineComponent({
  name: 'ProductVariantSelector',
  props: {
    productVariants: {
      type: Array as PropType<NonNullable<ProductContext['variants']>>,
      default: () => [],
    },
    isProductModal: {
      type: Boolean,
      default: false,
    },
  },
  setup({ productVariants, isProductModal }) {
    const { productOptions, selectedOptions } = useProductConfigurationOptions(isProductModal);

    function handleOnSelectOption(optionCode: string, value: string) {
      // if (selectedOptions.value?.[optionCode] && selectedOptions.value?.[optionCode] === value) {
      //   selectedOptions.value = omit(selectedOptions.value, optionCode);

      //   return;
      // }
      selectedOptions.value = { ...selectedOptions.value, [optionCode]: value };
    }

    function getVariantLabel(attrCode: string, optionUid: string) {
      const option = productOptions.value
        ?.find(option => option.attribute_code === attrCode)
        ?.values?.find(variant => variant.uid === optionUid);

      return option?.label;
    }

    /**
     * @param option: product option
     * loop over product variants and find at least one variant that have same passed option uid and the variant it self in stock
     * - if result is true, that means this option will be in stock for another variant
     */
    function activeOption(option: NonNullable<NonNullable<typeof productOptions.value>[number]['values']>[number]) {
      const variantStock = productVariants.some(
        variant => variant.attributes?.some(attr => attr?.uid === option.uid) && variant.stock
      );

      return variantStock && !!option.active;
    }

    return {
      productOptions,
      handleOnSelectOption,
      selectedOptions,
      isColor,
      getVariantLabel,
      activeOption,
    };
  },
});
